import { gql } from "@apollo/client";

export const SEARCH_ORGANIZATIONS = gql`
  query SearchOrganizations($text: String!, $from: Int, $size: Int) {
    searchOrganizations(text: $text, from: $from, size: $size) {
      id
      description
      name
      tagline
      alternateName
      email
      url
      ein
      deductibility
      subsection
      assetAmount
      nteeType
      incomeAmount
      nteeSuffix
      filingRequirement
      # classification
      latest990
      rulingDate
      nteeCode
      groupName
      deductibilityCode
      affiliation
      foundationStatus
      nteeClassification
      accountingPeriod
      exemptOrgStatus
      deductibilityDetail
      exemptOrgStatusCode
      nteeLetter
      programs {
        name
      }
      services {
        name
      }
      contacts {
        # name
        email
        title
      }
      locations {
        latitude
        longitude
        address
        city
        region
        stateOrProvince
        postalCode
        country
      }
      phones {
        number
      }
    }
  }
`;
